import { useTranslation } from "react-i18next";

import { PATHS } from "@/routes/paths";
import { NOTIFICATIONS_PLATFORM_FILTER_ENUM } from "@/utils/enums/notifications.enum";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface NotificationsFooterProps {
  setOpen: (open: boolean) => void;
  activeTab: string;
}

export const NotificationsFooter = ({
  setOpen,
  activeTab,
}: NotificationsFooterProps) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const handleClick = () => {
    setOpen(false);
    navigate(
      activeTab === NOTIFICATIONS_PLATFORM_FILTER_ENUM.COMPANY
        ? PATHS.COMPANY.COMPANY_NOTIFICATIONS_PATHS.ROOT
        : PATHS.COMMON_PATHS.NOTIFICATIONS,
    );
  };

  return (
    <div className="border-t bg-background">
      <button
        className="group flex w-full items-center justify-center gap-1.5 py-2.5 text-[11px] font-medium text-muted-foreground hover:text-primary transition-colors duration-150"
        onClick={handleClick}
      >
        {t("common:inbox.view_all_notifications")}
        <ArrowRight
          size={11}
          className="rtl-flip transition-transform duration-150 group-hover:translate-x-0.5"
        />
      </button>
    </div>
  );
};
